import { Button } from '@design-system';
import { useTranslation } from 'next-i18next';

import { Modal } from '../../../Dialog/Modal';

const OUTCOME_KEYS = ['beforeWindow', 'withinWindow', 'preOrder'] as const;

export interface HowPaymentWorksDialogProps {
  open: boolean;
  onClose: () => void;
}

export const HowPaymentWorksDialog = ({
  onClose,
  open,
}: HowPaymentWorksDialogProps) => {
  const { t } = useTranslation('checkout');
  const title = t('review.howPaymentWorks.title');

  return (
    <Modal
      dismissible
      onClose={onClose}
      open={open}
      overlayOtherDialogs
      title={title}
      verticalAlign="center"
    >
      <div className="relative flex max-h-[80dvh] w-full flex-col overflow-y-scroll rounded-t-lg bg-white no-scrollbar md:max-w-md md:overflow-y-auto md:rounded-lg">
        <div className="sticky top-0 z-30 flex w-full items-center justify-center bg-white p-6">
          <p className="text-center text-md font-bold">{title}</p>
          <div className="absolute right-5 top-5 flex h-9 w-9 items-center justify-center">
            <Button
              hideLabel
              icon="ic_close"
              label="Close"
              onClick={onClose}
              size="sm"
              type="button"
              variant="transparent"
            />
          </div>
        </div>

        <div className="flex flex-col gap-6 p-6 pt-0">
          <p className="text-pretty">{t('review.howPaymentWorks.intro')}</p>
          <p className="text-pretty">{t('review.howPaymentWorks.outcomes')}</p>

          <ul className="flex list-disc flex-col gap-3 pl-5">
            {OUTCOME_KEYS.map((outcomeKey) => (
              <li key={outcomeKey} className="text-pretty">
                <span className="font-bold">
                  {t(`review.howPaymentWorks.${outcomeKey}.label`)}
                </span>
                : {t(`review.howPaymentWorks.${outcomeKey}.text`)}
              </li>
            ))}
          </ul>

          <p className="text-pretty">
            <span className="font-bold">
              {t('review.howPaymentWorks.holdNote.label')}
            </span>{' '}
            {t('review.howPaymentWorks.holdNote.text')}
          </p>
        </div>
      </div>
    </Modal>
  );
};
